<template>
  <div class="headline">
    <div class="text">
      {{title}}
    </div>
    <div class="line">
    </div>
  </div>
</template>

<script>
 export default {
   name: 'Headline',
   props: [ 'title'],
   computed: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .headline {
   color: white;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 4vh;
 }
 .headline .text{
   font-size: 3.27vw;
   letter-spacing: 0.208vw;
   font-family: "Noto Sans SC", SourceHanSansCN-Bold;
   font-weight:bold;
 }
 .headline .line{
   height: 10px;
   width: 25vw;
   border-bottom: 0.5px solid white;
 }

</style>
